import tippy from 'tippy.js';
import {initTournamentSeasonSelects} from "../components/tournaments-seasons-selects";

export function initFullStatistics() {
    const $statsFullList = $('#full_statistics')
    const tablePreloader = $('#table_preloader');
    if (!$statsFullList.length) return

    const settings = $statsFullList.attr('data-settings')
    if (!settings.length) return
    const parsedSettings = JSON.parse(settings)

    let GOALKEEPERS = []
    let OTHERS = []

    $('.header').addClass('fixed');

    initTooltips()
    initTournamentSeasonSelects(parsedSettings, getFullStats);

    getFullStats()

    function getFullStats() {
        const data = {
            tournamentId: +$('[data-tournament-select]').val(),
            seasonId: +$('[data-season-select]').val()
        }


        $statsFullList.addClass('load')
        tablePreloader.removeClass('hide');
        $statsFullList.find('.statistics-head .sort').removeClass('asc desc')

        GOALKEEPERS = []
        OTHERS = []

        $.ajax({
            url: '/ajax/getPlayerStats/',
            type: 'POST',
            contentType: 'application/json',
            dataType: 'json',
            data: JSON.stringify(data),
            success: (res) => {
                if (res && res.length) {
                    renderStatsList(res)
                }

                setTimeout(() => {
                    $statsFullList.removeClass('load')
                    tablePreloader.addClass('hide')
                }, 500)

            },
            error: (res) => {
                renderStatsList(mockup)
                setTimeout(() => {
                    $statsFullList.removeClass('load')
                    tablePreloader.addClass('hide')
                }, 500)
            },
            timeout: 30000
        })
    }

    function rerenderGoalkeepersList() {
        $('[data-goalkeepers-list]').html(renderPlayersList(GOALKEEPERS))
    }

    function rerenderOthersList() {
        $('[data-others-list]').html(renderPlayersList(OTHERS))
    }

    function renderStatsList(data) {
        for (let i = 0; i < data.length; i++) {
            const item = data[i]
            const amplua = item.amplua
            let stats = item.stats



            if (!Object.keys(stats).length) {
                Object.assign(item.stats, {
                    games: 0,
                    goals: 0,
                    lineup: 0,
                    looseGoals: 0,
                    loosePenalty: 0,
                    minutes: 0,
                    penalty: 0,
                    redCards: 0,
                    saves: 0,
                    secondYellowCards: 0,
                    shutout: 0,
                    swapFrom: 0,
                    swapTo: 0,
                    unrealisedPenalty: 0,
                    winPenalty: 0,
                    yellowCards: 0
                })
            }


            if (amplua === 0) {
                GOALKEEPERS.push(item)
            } else {
                OTHERS.push(item)
            }
        }

        sortList(GOALKEEPERS, 'number', 'asc')
        sortList(OTHERS, 'number', 'asc')

        $('[data-goalkeepers-list]').html(renderPlayersList(GOALKEEPERS))
        $('[data-others-list]').html(renderPlayersList(OTHERS))
    }

    function renderPlayersList(list) {
        let result = ''
        for (let i = 0; i < list.length; i++) {
            result+=  getStatsPlayerRow(list[i])
        }

        return result
    }

    function getStatsPlayerRow(player) {
        if (!player) return

        const amplua = player.amplua
        const stats = player.stats || null

        if (!player.stats) return ''

        const link = player.link
        const number = player.number
        const flag = player.flag
        const lastname = player.lastname

        if (!Object.keys(player.stats).length) return '';

        const games = stats.games
        const minutes = stats.minutes
        const shutout = stats.shutout
        const goals = stats.goals
        const saves = stats.saves
        const looseGoals = stats.looseGoals
        const yellowCards = stats.yellowCards
        const secondYellowCards = stats.secondYellowCards
        const redCards = stats.redCards
        const swapTo = stats.swapTo
        const swapFrom = stats.swapFrom
        const lineup = stats.lineup
        const penalty = stats.penalty
        const unrealisedPenalty = stats.unrealisedPenalty


        if (amplua === 0) {
            return ` <div class="statistics-row closed">
                        <div class="item first-item">
                            <div class="flag" style="background-image: url(${flag})"></div>
                            <div class="number">${number}</div>
                            <a href="${link}" class="link">${lastname}</a>
                            <div class="item-toggle"></div>
                        </div>
                        <div class="item">
                            <div class="stat-name hide-desktop">
                                <div class="event field"></div>Игр
                            </div>
                            <div class="stat-number ${games > 0? 'gradient': ''}">${games}</div>
                        </div>
                        <div class="item">
                            <div class="stat-name hide-desktop">
                                <div class="event stopwatch"></div>
                                Минут на поле
                            </div>
                            <div class="stat-number ${minutes > 0? 'gradient': ''}">${minutes}</div>
                        </div>
                        <div class="item">
                            <div class="stat-name hide-desktop">
                                <div class="event goal-green"></div>
                                Сухих Матчей
                            </div>
                            <div class="stat-number ${shutout > 0? 'gradient': ''}">${shutout}</div>
                        </div>
                        <div class="item">
                            <div class="stat-name hide-desktop">
                                <div class="event goal-gray"></div>
                                Отбитые пенальти
                            </div>
                            <div class="stat-number ${saves > 0? 'gradient': ''}">${saves}</div>
                        </div>
                        <div class="item">
                            <div class="stat-name hide-desktop">
                                <div class="event goal-red"></div>
                                Пропущенные Голы
                            </div>
                            <div class="stat-number ${looseGoals > 0? 'gradient': ''}">${looseGoals}</div>
                        </div>
                        <div class="item">
                            <div class="stat-name hide-desktop">
                                <div class="event yellow-card"></div>
                                Желтые карточки
                            </div>
                            <div class="stat-number ${yellowCards > 0? 'gradient': ''}">${yellowCards}</div>
                        </div>
                        <div class="item">
                            <div class="stat-name hide-desktop">
                                <div class="event yellow-red-card"></div>
                                вторые желтые карточки
                            </div>
                            <div class="stat-number ${secondYellowCards > 0? 'gradient': ''}">${secondYellowCards}</div>
                        </div>
                        <div class="item">
                            <div class="stat-name hide-desktop">
                                <div class="event red-card"></div>
                                Красные карточки
                            </div>
                            <div class="stat-number ${redCards > 0? 'gradient': ''}">${redCards}</div>
                        </div>
                        <div class="item">
                            <div class="stat-name hide-desktop">
                                <div class="event swap-green"></div>
                                Выход на замену
                            </div>
                            <div class="stat-number ${swapTo > 0? 'gradient': ''}">${swapTo}</div>
                        </div>
                        <div class="item">
                            <div class="stat-name hide-desktop">
                                <div class="event swap-red"></div>
                                Был заменен
                            </div>
                            <div class="stat-number ${swapFrom > 0? 'gradient': ''}">${swapFrom}</div>
                        </div>
                        <div class="item">
                            <div class="stat-name hide-desktop">
                                <div class="event whistle"></div>
                                Заявлен в запас
                            </div>
                            <div class="stat-number ${lineup > 0? 'gradient': ''}">${lineup}</div>
                        </div>
                    </div>`
        }

        return `<div class="statistics-row closed">
                        <div class="item first-item">
                            <div class="flag" style="background-image: url(${flag})"></div>
                            <div class="number">${number}</div>
                            <a href="${link}" class="link">${lastname}</a>
                            <div class="item-toggle"></div>
                        </div>
                        <div class="item">
                            <div class="stat-name hide-desktop">
                                <div class="event field"></div>Игр
                            </div>
                            <div class="stat-number ${games > 0? 'gradient': ''}">${games}</div>
                        </div>
                        <div class="item">
                            <div class="stat-name hide-desktop">
                                <div class="event stopwatch"></div>
                                Минут на поле
                            </div>
                            <div class="stat-number ${minutes > 0? 'gradient': ''}">${minutes}</div>
                        </div>
                        <div class="item">
                            <div class="stat-name hide-desktop">
                                <div class="event goal-gray"></div>
                               Голы
                            </div>
                            <div class="stat-number ${goals > 0? 'gradient': ''}">${goals}</div>
                        </div>
                        <div class="item">
                            <div class="stat-name hide-desktop">
                                <div class="event goal-gray"></div>
                                Пенальти
                            </div>
                            <div class="stat-number ${penalty > 0? 'gradient': ''}">${penalty}</div>
                        </div>
                        <div class="item">
                            <div class="stat-name hide-desktop">
                                <div class="event goal-red"></div>
                                нереализованные пенальти
                            </div>
                            <div class="stat-number ${unrealisedPenalty > 0? 'gradient': ''}">${unrealisedPenalty}</div>
                        </div>
                        <div class="item">
                            <div class="stat-name hide-desktop">
                                <div class="event yellow-card"></div>
                                Желтые карточки
                            </div>
                            <div class="stat-number ${yellowCards > 0? 'gradient': ''}">${yellowCards}</div>
                        </div>
                        <div class="item">
                            <div class="stat-name hide-desktop">
                                <div class="event yellow-red-card"></div>
                                вторые желтые карточки
                            </div>
                            <div class="stat-number ${secondYellowCards > 0? 'gradient': ''}">${secondYellowCards}</div>
                        </div>
                        <div class="item">
                            <div class="stat-name hide-desktop">
                                <div class="event red-card"></div>
                                Красные карточки
                            </div>
                            <div class="stat-number ${redCards > 0? 'gradient': ''}">${redCards}</div>
                        </div>
                        <div class="item">
                            <div class="stat-name hide-desktop">
                                <div class="event swap-green"></div>
                                Выход на замену
                            </div>
                            <div class="stat-number ${swapTo > 0? 'gradient': ''}">${swapTo}</div>
                        </div>
                        <div class="item">
                            <div class="stat-name hide-desktop">
                                <div class="event swap-red"></div>
                                Был заменен
                            </div>
                            <div class="stat-number ${swapFrom > 0? 'gradient': ''}">${swapFrom}</div>
                        </div>
                        <div class="item">
                            <div class="stat-name hide-desktop">
                                <div class="event whistle"></div>
                                Заявлен в запас
                            </div>
                            <div class="stat-number ${lineup > 0? 'gradient': ''}">${lineup}</div>
                        </div>
                    </div>`
    }

    function initTooltips() {
        $.each($('[data-tooltip]'), function () {
            tippy($(this)[0], {
                arrow: false,
                content: $(this).attr('data-tooltip')
            })
        })
    }

    function sortList(array, type, direction) {
        if (!type) return

        switch (type) {
            case 'number':
                array.sort((a, b) => +a.number > +b.number ? 1 : -1)
                break

            case 'games':
                if (direction === 'asc') {
                    array.sort((a, b) => +a.stats?.games > +b.stats?.games ? 1 : -1)
                } else {
                    array.sort((a, b) => +a.stats?.games < +b.stats?.games ? 1 : -1)
                }
                break

            case 'minutes':
                if (direction === 'asc') {
                    array.sort((a, b) => +a.stats?.minutes > +b.stats?.minutes ? 1 : -1)
                } else {
                    array.sort((a, b) => +a.stats?.minutes < +b.stats?.minutes ? 1 : -1)
                }

                break

            case 'goals':
                if (direction === 'asc') {
                    array.sort((a, b) => +a.stats?.goals > +b.stats?.goals ? 1 : -1)
                } else {
                    array.sort((a, b) => +a.stats?.goals < +b.stats?.goals ? 1 : -1)
                }
                break

            case 'penalty':
                if (direction === 'asc') {
                    array.sort((a, b) => +a.stats?.penalty > +b.stats?.penalty ? 1 : -1)
                } else {
                    array.sort((a, b) => +a.stats?.penalty < +b.stats?.penalty ? 1 : -1)
                }
                break

            case 'unrealisedPenalty':
                if (direction === 'asc') {
                    array.sort((a, b) => +a.stats?.unrealisedPenalty > +b.stats?.unrealisedPenalty ? 1 : -1)
                } else {
                    array.sort((a, b) => +a.stats?.unrealisedPenalty < +b.stats?.unrealisedPenalty ? 1 : -1)
                }
                break

            case 'yellowCards':
                if (direction === 'asc') {
                    array.sort((a, b) => +a.stats?.yellowCards > +b.stats?.yellowCards ? 1 : -1)
                } else {
                    array.sort((a, b) => +a.stats?.yellowCards < +b.stats?.yellowCards ? 1 : -1)
                }
                break

            case 'secondYellowCards':
                if (direction === 'asc') {
                    array.sort((a, b) => +a.stats?.secondYellowCards > +b.stats?.secondYellowCards ? 1 : -1)
                } else {
                    array.sort((a, b) => +a.stats?.secondYellowCards < +b.stats?.secondYellowCards ? 1 : -1)
                }
                break

            case 'redCards':
                if (direction === 'asc') {
                    array.sort((a, b) => +a.stats?.redCards > +b.stats?.redCards ? 1 : -1)
                } else {
                    array.sort((a, b) => +a.stats?.redCards < +b.stats?.redCards ? 1 : -1)
                }
                break

            case 'swapTo':
                if (direction === 'asc') {
                    array.sort((a, b) => +a.stats?.swapTo > +b.stats?.swapTo ? 1 : -1)
                } else {
                    array.sort((a, b) => +a.stats?.swapTo < +b.stats?.swapTo ? 1 : -1)
                }
                break

            case 'swapFrom':
                if (direction === 'asc') {
                    array.sort((a, b) => +a.stats?.swapFrom > +b.stats?.swapFrom ? 1 : -1)
                } else {
                    array.sort((a, b) => +a.stats?.swapFrom < +b.stats?.swapFrom ? 1 : -1)
                }
                break

            case 'lineup':
                if (direction === 'asc') {
                    array.sort((a, b) => +a.stats?.lineup > +b.stats?.lineup ? 1 : -1)
                } else {
                    array.sort((a, b) => +a.stats?.lineup < +b.stats?.lineup ? 1 : -1)
                }
                break

            case 'shutout':
                if (direction === 'asc') {
                    array.sort((a, b) => +a.stats?.shutout > +b.stats?.shutout ? 1 : -1)
                } else {
                    array.sort((a, b) => +a.stats?.shutout < +b.stats?.shutout ? 1 : -1)
                }
                break

            case 'saves':
                if (direction === 'asc') {
                    array.sort((a, b) => +a.stats?.saves > +b.stats?.saves ? 1 : -1)
                } else {
                    array.sort((a, b) => +a.stats?.saves < +b.stats?.saves ? 1 : -1)
                }
                break

            case 'looseGoals':
                if (direction === 'asc') {
                    array.sort((a, b) => +a.stats?.looseGoals > +b.stats?.looseGoals ? 1 : -1)
                } else {
                    array.sort((a, b) => +a.stats?.looseGoals < +b.stats?.looseGoals ? 1 : -1)
                }
                break

            default:
                array.sort((a, b) => +a.number > +b.number ? 1 : -1)
                break
        }
    }

    $('body').on('click', '.statistics-head .sort', function () {
        const type = $(this).parents('.statistics-head').attr('data-type')
        const sortType = $(this).attr('data-sort')
        let sortDirection = 'desc'

        if ($(this).hasClass('desc')) {
            $(this).removeClass('desc').addClass('ask')
            sortDirection = 'asc'
        } else {
            $(this).addClass('desc').removeClass('asc')
            sortDirection = 'desc'
        }

        $(this).siblings().removeClass('asc desc')

        if (type === 'goalkeepers') {
            sortList(GOALKEEPERS, sortType, sortDirection)
            rerenderGoalkeepersList()
        } else {
            sortList(OTHERS, sortType, sortDirection)
            rerenderOthersList()
        }

        return false
    })

    $('body').on('click', '.statistics-row .item-toggle', function() {
        const $this = $(this)
        const $parent = $this.parents('.statistics-row')

        $parent.toggleClass('closed')
    })

    const mockup = [
        {
            "amplua": 2,
            "flag": "\/public\/img\/flags\/1.gif",
            "lastname": "\u0411\u0443\u043b\u0433\u0430\u043a\u043e\u0432",
            "number": 73,
            "link": "\/team\/player-statistics\/igroki_88.html",
            "stats": []
        },
        {
            "amplua": 1,
            "flag": "\/public\/img\/flags\/1.gif",
            "lastname": "\u0413\u0430\u043f\u043e\u043d\u043e\u0432",
            "number": 95,
            "link": "\/team\/player-statistics\/igroki_87.html",
            "stats": {
                "games": 2,
                "goals": 0,
                "lineup": 2,
                "looseGoals": 0,
                "loosePenalty": 0,
                "minutes": 185,
                "penalty": 0,
                "redCards": 0,
                "saves": 0,
                "secondYellowCards": 0,
                "shutout": 0,
                "swapFrom": 0,
                "swapTo": 0,
                "unrealisedPenalty": 0,
                "winPenalty": 0,
                "yellowCards": 0
            }
        },
        {
            "amplua": 1,
            "flag": "\/public\/img\/flags\/34.gif",
            "lastname": "\u0411\u0430\u0440\u0430\u0447",
            "number": 44,
            "link": "\/team\/player-statistics\/igroki_85.html",
            "stats": {
                "games": 0,
                "goals": 0,
                "lineup": 0,
                "looseGoals": 0,
                "loosePenalty": 0,
                "minutes": 0,
                "penalty": 0,
                "redCards": 0,
                "saves": 0,
                "secondYellowCards": 0,
                "shutout": 0,
                "swapFrom": 0,
                "swapTo": 0,
                "unrealisedPenalty": 0,
                "winPenalty": 0,
                "yellowCards": 0
            }
        },
        {
            "amplua": 2,
            "flag": "\/public\/img\/flags\/1.gif",
            "lastname": "\u0424\u043e\u043c\u0435\u043d\u043a\u043e",
            "number": 51,
            "link": "\/team\/player-statistics\/igroki_84.html",
            "stats": []
        },
        {
            "amplua": 2,
            "flag": "\/public\/img\/flags\/1.gif",
            "lastname": "\u0421\u043e\u043a\u043e\u043b\u043e\u0432",
            "number": 77,
            "link": "\/team\/player-statistics\/igroki_83.html",
            "stats": {
                "games": 1,
                "goals": 0,
                "lineup": 0,
                "looseGoals": 0,
                "loosePenalty": 0,
                "minutes": 11,
                "penalty": 0,
                "redCards": 0,
                "saves": 0,
                "secondYellowCards": 0,
                "shutout": 0,
                "swapFrom": 0,
                "swapTo": 1,
                "unrealisedPenalty": 0,
                "winPenalty": 0,
                "yellowCards": 0
            }
        },
        {
            "amplua": 1,
            "flag": "\/public\/img\/flags\/17.gif",
            "lastname": "\u041a\u043e\u0441\u0442\u0430\u043d\u0446\u0430",
            "number": 22,
            "link": "\/team\/player-statistics\/igroki_82.html",
            "stats": {
                "games": 1,
                "goals": 0,
                "lineup": 1,
                "looseGoals": 0,
                "loosePenalty": 0,
                "minutes": 93,
                "penalty": 0,
                "redCards": 0,
                "saves": 0,
                "secondYellowCards": 0,
                "shutout": 0,
                "swapFrom": 0,
                "swapTo": 0,
                "unrealisedPenalty": 0,
                "winPenalty": 0,
                "yellowCards": 0
            }
        },
        {
            "amplua": 3,
            "flag": "\/public\/img\/flags\/1.gif",
            "lastname": "\u0418\u0433\u043d\u0430\u0442\u044c\u0435\u0432",
            "number": 85,
            "link": "\/team\/player-statistics\/igroki_81.html",
            "stats": {
                "games": 0,
                "goals": 0,
                "lineup": 0,
                "looseGoals": 0,
                "loosePenalty": 0,
                "minutes": 0,
                "penalty": 0,
                "redCards": 0,
                "saves": 0,
                "secondYellowCards": 0,
                "shutout": 0,
                "swapFrom": 0,
                "swapTo": 0,
                "unrealisedPenalty": 0,
                "winPenalty": 0,
                "yellowCards": 0
            }
        },
        {
            "amplua": 1,
            "flag": "\/public\/img\/flags\/1.gif",
            "lastname": "\u0413\u0443\u0434\u043a\u043e\u0432",
            "number": 66,
            "link": "\/team\/player-statistics\/igroki_80.html",
            "stats": {
                "games": 0,
                "goals": 0,
                "lineup": 0,
                "looseGoals": 0,
                "loosePenalty": 0,
                "minutes": 0,
                "penalty": 0,
                "redCards": 0,
                "saves": 0,
                "secondYellowCards": 0,
                "shutout": 0,
                "swapFrom": 0,
                "swapTo": 0,
                "unrealisedPenalty": 0,
                "winPenalty": 0,
                "yellowCards": 0
            }
        },
        {
            "amplua": 2,
            "flag": "\/public\/img\/flags\/1.gif",
            "lastname": "\u041a\u043e\u0432\u0430\u043b\u0435\u043d\u043a\u043e",
            "number": 14,
            "link": "\/team\/player-statistics\/igroki_79.html",
            "stats": {
                "games": 2,
                "goals": 0,
                "lineup": 2,
                "looseGoals": 0,
                "loosePenalty": 0,
                "minutes": 165,
                "penalty": 0,
                "redCards": 0,
                "saves": 0,
                "secondYellowCards": 0,
                "shutout": 0,
                "swapFrom": 1,
                "swapTo": 0,
                "unrealisedPenalty": 0,
                "winPenalty": 0,
                "yellowCards": 0
            }
        },
        {
            "amplua": 2,
            "flag": "\/public\/img\/flags\/1.gif",
            "lastname": "\u0425\u0440\u0438\u0441\u0430\u043d\u0444\u043e\u0432",
            "number": 75,
            "link": "\/team\/player-statistics\/igroki_78.html",
            "stats": []
        },
        {
            "amplua": 2,
            "flag": "\/public\/img\/flags\/1.gif",
            "lastname": "\u0424\u0430\u0434\u0435\u0435\u0432",
            "number": 98,
            "link": "\/team\/player-statistics\/igroki_77.html",
            "stats": []
        },
        {
            "amplua": 2,
            "flag": "\/public\/img\/flags\/1.gif",
            "lastname": "\u041e\u043b\u0438\u0439\u043d\u044b\u043a",
            "number": 82,
            "link": "\/team\/player-statistics\/igroki_76.html",
            "stats": []
        },
        {
            "amplua": 1,
            "flag": "\/public\/img\/flags\/1.gif",
            "lastname": "\u0417\u0430\u0433\u043e\u0440\u043e\u0434\u043d\u0438\u043a\u043e\u0432",
            "number": 89,
            "link": "\/team\/player-statistics\/igroki_75.html",
            "stats": []
        },
        {
            "amplua": 1,
            "flag": "\/public\/img\/flags\/1.gif",
            "lastname": "\u0420\u0430\u0434\u0430\u0435\u0432",
            "number": 56,
            "link": "\/team\/player-statistics\/igroki_74.html",
            "stats": []
        },
        {
            "amplua": 0,
            "flag": "\/public\/img\/flags\/1.gif",
            "lastname": "\u0411\u043e\u0440\u0438\u0441\u043e\u0432",
            "number": 88,
            "link": "\/team\/player-statistics\/igroki_72.html",
            "stats": []
        },
        {
            "amplua": 2,
            "flag": "\/public\/img\/flags\/1.gif",
            "lastname": "\u0410\u043d\u0434\u0440\u0435\u0435\u0432",
            "number": 79,
            "link": "\/team\/player-statistics\/igroki_71.html",
            "stats": []
        },
        {
            "amplua": 1,
            "flag": "\/public\/img\/flags\/1.gif",
            "lastname": "\u0413\u0440\u0435\u0431\u0451\u043d\u043a\u0438\u043d",
            "number": 84,
            "link": "\/team\/player-statistics\/igroki_70.html",
            "stats": []
        },
        {
            "amplua": 2,
            "flag": "\/public\/img\/flags\/1.gif",
            "lastname": "\u0427\u0430\u043b\u044b\u0439",
            "number": 55,
            "link": "\/team\/player-statistics\/igroki_69.html",
            "stats": []
        },
        {
            "amplua": 0,
            "flag": "\/public\/img\/flags\/1.gif",
            "lastname": "\u0411\u044b\u0447\u0435\u043d\u043a\u043e",
            "number": 70,
            "link": "\/team\/player-statistics\/igroki_68.html",
            "stats": []
        },
        {
            "amplua": 1,
            "flag": "\/public\/img\/flags\/1.gif",
            "lastname": "\u0422\u0435\u043f\u043b\u044f\u043a\u043e\u0432",
            "number": 72,
            "link": "\/team\/player-statistics\/igroki_66.html",
            "stats": []
        },
        {
            "amplua": 1,
            "flag": "\/public\/img\/flags\/1.gif",
            "lastname": "\u0420\u043e\u043c\u0430\u043d\u043e\u0432",
            "number": 80,
            "link": "\/team\/player-statistics\/igroki_65.html",
            "stats": []
        },
        {
            "amplua": 1,
            "flag": null,
            "lastname": "\u0411\u0435\u0433\u0438\u0447",
            "number": 2,
            "link": "\/team\/player-statistics\/igroki_63.html",
            "stats": {
                "games": 1,
                "goals": 0,
                "lineup": 1,
                "looseGoals": 0,
                "loosePenalty": 0,
                "minutes": 93,
                "penalty": 0,
                "redCards": 0,
                "saves": 0,
                "secondYellowCards": 0,
                "shutout": 0,
                "swapFrom": 0,
                "swapTo": 0,
                "unrealisedPenalty": 0,
                "winPenalty": 0,
                "yellowCards": 0
            }
        },
        {
            "amplua": 2,
            "flag": "\/public\/img\/flags\/1.gif",
            "lastname": "\u041c\u043e\u0442\u043e\u0432\u0438\u0447\u0451\u0432",
            "number": 93,
            "link": "\/team\/player-statistics\/igroki_62.html",
            "stats": []
        },
        {
            "amplua": 3,
            "flag": null,
            "lastname": "\u0410\u0440\u043e\u043d\u043e\u0432",
            "number": 43,
            "link": "\/team\/player-statistics\/igroki_61.html",
            "stats": []
        },
        {
            "amplua": 3,
            "flag": "\/public\/img\/flags\/1.gif",
            "lastname": "\u0413\u043b\u0443\u0448\u0435\u043d\u043a\u043e\u0432",
            "number": 15,
            "link": "\/team\/player-statistics\/igroki_60.html",
            "stats": {
                "games": 7,
                "goals": 2,
                "lineup": 5,
                "looseGoals": 0,
                "loosePenalty": 0,
                "minutes": 407,
                "penalty": 0,
                "redCards": 0,
                "saves": 0,
                "secondYellowCards": 0,
                "shutout": 0,
                "swapFrom": 5,
                "swapTo": 2,
                "unrealisedPenalty": 0,
                "winPenalty": 0,
                "yellowCards": 0
            }
        },
        {
            "amplua": 2,
            "flag": "\/public\/img\/flags\/1.gif",
            "lastname": "\u041f\u0438\u043d\u044f\u0435\u0432",
            "number": 9,
            "link": "\/team\/player-statistics\/igroki_59.html",
            "stats": {
                "games": 8,
                "goals": 0,
                "lineup": 0,
                "looseGoals": 0,
                "loosePenalty": 0,
                "minutes": 133,
                "penalty": 0,
                "redCards": 0,
                "saves": 0,
                "secondYellowCards": 0,
                "shutout": 0,
                "swapFrom": 0,
                "swapTo": 8,
                "unrealisedPenalty": 0,
                "winPenalty": 0,
                "yellowCards": 0
            }
        },
        {
            "amplua": 2,
            "flag": "\/public\/img\/flags\/1.gif",
            "lastname": "\u0421\u043c\u0438\u0440\u043d\u043e\u0432",
            "number": 52,
            "link": "\/team\/player-statistics\/igroki_58.html",
            "stats": {
                "games": 0,
                "goals": 0,
                "lineup": 0,
                "looseGoals": 0,
                "loosePenalty": 0,
                "minutes": 0,
                "penalty": 0,
                "redCards": 0,
                "saves": 0,
                "secondYellowCards": 0,
                "shutout": 0,
                "swapFrom": 0,
                "swapTo": 0,
                "unrealisedPenalty": 0,
                "winPenalty": 0,
                "yellowCards": 0
            }
        },
        {
            "amplua": 2,
            "flag": "\/public\/img\/flags\/1.gif",
            "lastname": "\u041f\u0440\u0443\u0446\u0435\u0432",
            "number": 25,
            "link": "\/team\/player-statistics\/igroki_57.html",
            "stats": {
                "games": 7,
                "goals": 0,
                "lineup": 4,
                "looseGoals": 0,
                "loosePenalty": 0,
                "minutes": 409,
                "penalty": 0,
                "redCards": 0,
                "saves": 0,
                "secondYellowCards": 0,
                "shutout": 0,
                "swapFrom": 3,
                "swapTo": 3,
                "unrealisedPenalty": 0,
                "winPenalty": 0,
                "yellowCards": 2
            }
        },
        {
            "amplua": 1,
            "flag": "\/public\/img\/flags\/643.gif",
            "lastname": "\u0411\u0435\u0439\u043b",
            "number": 23,
            "link": "\/team\/player-statistics\/igroki_56.html",
            "stats": {
                "games": 3,
                "goals": 0,
                "lineup": 3,
                "looseGoals": 0,
                "loosePenalty": 0,
                "minutes": 255,
                "penalty": 0,
                "redCards": 0,
                "saves": 0,
                "secondYellowCards": 0,
                "shutout": 0,
                "swapFrom": 1,
                "swapTo": 0,
                "unrealisedPenalty": 0,
                "winPenalty": 0,
                "yellowCards": 1
            }
        },
        {
            "amplua": 2,
            "flag": "\/public\/img\/flags\/1.gif",
            "lastname": "\u041e\u0441\u0442\u0430\u043d\u0438\u043d",
            "number": 61,
            "link": "\/team\/player-statistics\/igroki_55.html",
            "stats": []
        },
        {
            "amplua": 2,
            "flag": null,
            "lastname": "\u0421\u0430\u043b\u043c\u0438\u043d",
            "number": 87,
            "link": "\/team\/player-statistics\/igroki_53.html",
            "stats": []
        },
        {
            "amplua": 0,
            "flag": "\/public\/img\/flags\/1.gif",
            "lastname": "\u0422\u0438\u043c\u0447\u0435\u043d\u043a\u043e",
            "number": 91,
            "link": "\/team\/player-statistics\/igroki_52.html",
            "stats": []
        },
        {
            "amplua": 1,
            "flag": null,
            "lastname": "\u0421\u0438\u043c\u0431\u0430\u0435\u0432",
            "number": 62,
            "link": "\/team\/player-statistics\/igroki_50.html",
            "stats": []
        },
        {
            "amplua": 1,
            "flag": "\/public\/img\/flags\/1.gif",
            "lastname": "\u042d\u043b\u0438\u0431\u0435\u043a\u044f\u043d",
            "number": 97,
            "link": "\/team\/player-statistics\/igroki_49.html",
            "stats": []
        },
        {
            "amplua": 2,
            "flag": "\/public\/img\/flags\/1.gif",
            "lastname": "\u041c\u0430\u043a\u0441\u0438\u043c\u043e\u0432",
            "number": 53,
            "link": "\/team\/player-statistics\/igroki_45.html",
            "stats": []
        },
        {
            "amplua": 3,
            "flag": "\/public\/img\/flags\/1.gif",
            "lastname": "\u041c\u0430\u043a\u0430\u0440\u043e\u0432",
            "number": 54,
            "link": "\/team\/player-statistics\/igroki_44.html",
            "stats": []
        },
        {
            "amplua": 0,
            "flag": null,
            "lastname": "\u041a\u0440\u0430\u0441\u0438\u043b\u044c\u043d\u0438\u043a\u043e\u0432",
            "number": 90,
            "link": "\/team\/player-statistics\/igroki_43.html",
            "stats": []
        },
        {
            "amplua": 3,
            "flag": null,
            "lastname": "\u041a\u043d\u044f\u0437\u044c\u043a\u043e\u0432",
            "number": 60,
            "link": "\/team\/player-statistics\/igroki_42.html",
            "stats": []
        },
        {
            "amplua": 1,
            "flag": null,
            "lastname": "\u041a\u0438\u0441\u0435\u043b\u0451\u0432",
            "number": 95,
            "link": "\/team\/player-statistics\/igroki_41.html",
            "stats": []
        },
        {
            "amplua": 1,
            "flag": null,
            "lastname": "\u0415\u0440\u043c\u0430\u043a\u043e\u0432",
            "number": 67,
            "link": "\/team\/player-statistics\/igroki_40.html",
            "stats": []
        },
        {
            "amplua": 1,
            "flag": "\/public\/img\/flags\/1.gif",
            "lastname": "\u0415\u0440\u0451\u043c\u0438\u043d",
            "number": 92,
            "link": "\/team\/player-statistics\/igroki_39.html",
            "stats": []
        },
        {
            "amplua": 3,
            "flag": "\/public\/img\/flags\/1.gif",
            "lastname": "\u0412\u043e\u0440\u043e\u0431\u044c\u0451\u0432",
            "number": 86,
            "link": "\/team\/player-statistics\/igroki_37.html",
            "stats": []
        },
        {
            "amplua": 2,
            "flag": null,
            "lastname": "\u0410\u0443\u0445\u0430\u0434\u0435\u0435\u0432",
            "number": 83,
            "link": "\/team\/player-statistics\/igroki_35.html",
            "stats": []
        },
        {
            "amplua": 3,
            "flag": "\/public\/img\/flags\/1.gif",
            "lastname": "\u041e\u043d\u0443\u0433\u0445\u0430",
            "number": 20,
            "link": "\/team\/player-statistics\/igroki_34.html",
            "stats": {
                "games": 4,
                "goals": 0,
                "lineup": 1,
                "looseGoals": 0,
                "loosePenalty": 0,
                "minutes": 89,
                "penalty": 0,
                "redCards": 0,
                "saves": 0,
                "secondYellowCards": 0,
                "shutout": 0,
                "swapFrom": 1,
                "swapTo": 3,
                "unrealisedPenalty": 0,
                "winPenalty": 0,
                "yellowCards": 0
            }
        },
        {
            "amplua": 1,
            "flag": null,
            "lastname": "\u0410\u043a\u0441\u0430\u043d\u043e\u0432",
            "number": 76,
            "link": "\/team\/player-statistics\/igroki_33.html",
            "stats": []
        },
        {
            "amplua": 3,
            "flag": "\/public\/img\/flags\/1.gif",
            "lastname": "\u0422\u043e\u0446\u043a\u0438\u0439",
            "number": 96,
            "link": "\/team\/player-statistics\/igroki_32.html",
            "stats": []
        },
        {
            "amplua": 3,
            "flag": "\/public\/img\/flags\/1.gif",
            "lastname": "\u0412\u043e\u0439\u0447\u0435\u043d\u043a\u043e",
            "number": 68,
            "link": "\/team\/player-statistics\/igroki_31.html",
            "stats": []
        },
        {
            "amplua": 0,
            "flag": "\/public\/img\/flags\/1.gif",
            "lastname": "\u0411\u0435\u043b\u044c\u0442\u044e\u043a\u043e\u0432",
            "number": 71,
            "link": "\/team\/player-statistics\/igroki_30.html",
            "stats": []
        },
        {
            "amplua": 1,
            "flag": null,
            "lastname": "\u041f\u0440\u0438\u0449\u0435\u043f\u0430",
            "number": 35,
            "link": "\/team\/player-statistics\/igroki_28.html",
            "stats": []
        },
        {
            "amplua": 2,
            "flag": "\/public\/img\/flags\/1.gif",
            "lastname": "\u042f\u043a\u0443\u0431\u0430",
            "number": 6,
            "link": "\/team\/player-statistics\/igroki_27.html",
            "stats": {
                "games": 5,
                "goals": 0,
                "lineup": 3,
                "looseGoals": 0,
                "loosePenalty": 0,
                "minutes": 210,
                "penalty": 0,
                "redCards": 0,
                "saves": 0,
                "secondYellowCards": 0,
                "shutout": 0,
                "swapFrom": 3,
                "swapTo": 2,
                "unrealisedPenalty": 0,
                "winPenalty": 0,
                "yellowCards": 1
            }
        },
        {
            "amplua": 1,
            "flag": "\/public\/img\/flags\/61.gif",
            "lastname": "\u0417\u0435\u0444\u0444\u0430\u043d",
            "number": 18,
            "link": "\/team\/player-statistics\/igroki_26.html",
            "stats": {
                "games": 7,
                "goals": 0,
                "lineup": 6,
                "looseGoals": 0,
                "loosePenalty": 0,
                "minutes": 544,
                "penalty": 0,
                "redCards": 0,
                "saves": 0,
                "secondYellowCards": 0,
                "shutout": 0,
                "swapFrom": 2,
                "swapTo": 1,
                "unrealisedPenalty": 0,
                "winPenalty": 0,
                "yellowCards": 0
            }
        },
        {
            "amplua": 3,
            "flag": "\/public\/img\/flags\/1.gif",
            "lastname": "\u0426\u044b\u043f\u0447\u0435\u043d\u043a\u043e",
            "number": 19,
            "link": "\/team\/player-statistics\/igroki_25.html",
            "stats": {
                "games": 5,
                "goals": 0,
                "lineup": 0,
                "looseGoals": 0,
                "loosePenalty": 0,
                "minutes": 71,
                "penalty": 0,
                "redCards": 0,
                "saves": 0,
                "secondYellowCards": 0,
                "shutout": 0,
                "swapFrom": 0,
                "swapTo": 5,
                "unrealisedPenalty": 0,
                "winPenalty": 0,
                "yellowCards": 0
            }
        },
        {
            "amplua": 0,
            "flag": "\/public\/img\/flags\/1.gif",
            "lastname": "\u0424\u0440\u043e\u043b\u043e\u0432",
            "number": 39,
            "link": "\/team\/player-statistics\/igroki_24.html",
            "stats": {
                "games": 0,
                "goals": 0,
                "lineup": 0,
                "looseGoals": 0,
                "loosePenalty": 0,
                "minutes": 0,
                "penalty": 0,
                "redCards": 0,
                "saves": 0,
                "secondYellowCards": 0,
                "shutout": 3,
                "swapFrom": 0,
                "swapTo": 0,
                "unrealisedPenalty": 0,
                "winPenalty": 0,
                "yellowCards": 0
            }
        },
        {
            "amplua": 0,
            "flag": "\/public\/img\/flags\/1.gif",
            "lastname": "\u041b\u043e\u043c\u0430\u0435\u0432",
            "number": 1,
            "link": "\/team\/player-statistics\/igroki_23.html",
            "stats": {
                "games": 9,
                "goals": 0,
                "lineup": 9,
                "looseGoals": 9,
                "loosePenalty": 0,
                "minutes": 845,
                "penalty": 0,
                "redCards": 0,
                "saves": 43,
                "secondYellowCards": 0,
                "shutout": 3,
                "swapFrom": 0,
                "swapTo": 0,
                "unrealisedPenalty": 0,
                "winPenalty": 0,
                "yellowCards": 1
            }
        },
        {
            "amplua": 2,
            "flag": "\/public\/img\/flags\/2.gif",
            "lastname": "\u0418\u0432\u0430\u043d\u0438\u0441\u0435\u043d\u044f",
            "number": 21,
            "link": "\/team\/player-statistics\/igroki_22.html",
            "stats": {
                "games": 7,
                "goals": 0,
                "lineup": 7,
                "looseGoals": 0,
                "loosePenalty": 0,
                "minutes": 629,
                "penalty": 0,
                "redCards": 0,
                "saves": 0,
                "secondYellowCards": 0,
                "shutout": 0,
                "swapFrom": 2,
                "swapTo": 0,
                "unrealisedPenalty": 0,
                "winPenalty": 0,
                "yellowCards": 2
            }
        },
        {
            "amplua": 1,
            "flag": "\/public\/img\/flags\/1.gif",
            "lastname": "\u0427\u0435\u0440\u043d\u043e\u0432",
            "number": 3,
            "link": "\/team\/player-statistics\/igroki_21.html",
            "stats": {
                "games": 5,
                "goals": 1,
                "lineup": 5,
                "looseGoals": 0,
                "loosePenalty": 0,
                "minutes": 470,
                "penalty": 0,
                "redCards": 0,
                "saves": 0,
                "secondYellowCards": 0,
                "shutout": 0,
                "swapFrom": 0,
                "swapTo": 0,
                "unrealisedPenalty": 0,
                "winPenalty": 0,
                "yellowCards": 1
            }
        },
        {
            "amplua": 1,
            "flag": "\/public\/img\/flags\/1.gif",
            "lastname": "\u0421\u043e\u043b\u0434\u0430\u0442\u0435\u043d\u043a\u043e\u0432",
            "number": 4,
            "link": "\/team\/player-statistics\/igroki_20.html",
            "stats": {
                "games": 8,
                "goals": 0,
                "lineup": 8,
                "looseGoals": 0,
                "loosePenalty": 0,
                "minutes": 752,
                "penalty": 0,
                "redCards": 0,
                "saves": 0,
                "secondYellowCards": 0,
                "shutout": 0,
                "swapFrom": 0,
                "swapTo": 0,
                "unrealisedPenalty": 0,
                "winPenalty": 0,
                "yellowCards": 1
            }
        },
        {
            "amplua": 3,
            "flag": "\/public\/img\/flags\/1.gif",
            "lastname": "\u0421\u0435\u0440\u0433\u0435\u0435\u0432",
            "number": 33,
            "link": "\/team\/player-statistics\/igroki_19.html",
            "stats": {
                "games": 7,
                "goals": 3,
                "lineup": 6,
                "looseGoals": 0,
                "loosePenalty": 0,
                "minutes": 576,
                "penalty": 1,
                "redCards": 0,
                "saves": 0,
                "secondYellowCards": 0,
                "shutout": 0,
                "swapFrom": 3,
                "swapTo": 1,
                "unrealisedPenalty": 0,
                "winPenalty": 1,
                "yellowCards": 0
            }
        },
        {
            "amplua": 3,
            "flag": "\/public\/img\/flags\/1.gif",
            "lastname": "\u0421\u0430\u0440\u0432\u0435\u043b\u0438",
            "number": 10,
            "link": "\/team\/player-statistics\/igroki_18.html",
            "stats": {
                "games": 8,
                "goals": 2,
                "lineup": 6,
                "looseGoals": 0,
                "loosePenalty": 0,
                "minutes": 495,
                "penalty": 0,
                "redCards": 0,
                "saves": 0,
                "secondYellowCards": 0,
                "shutout": 0,
                "swapFrom": 6,
                "swapTo": 2,
                "unrealisedPenalty": 0,
                "winPenalty": 0,
                "yellowCards": 1
            }
        },
        {
            "amplua": 0,
            "flag": "\/public\/img\/flags\/1.gif",
            "lastname": "\u041e\u0432\u0441\u044f\u043d\u043d\u0438\u043a\u043e\u0432",
            "number": 81,
            "link": "\/team\/player-statistics\/igroki_17.html",
            "stats": {
                "games": 0,
                "goals": 0,
                "lineup": 0,
                "looseGoals": 0,
                "loosePenalty": 0,
                "minutes": 0,
                "penalty": 0,
                "redCards": 0,
                "saves": 0,
                "secondYellowCards": 0,
                "shutout": 3,
                "swapFrom": 0,
                "swapTo": 0,
                "unrealisedPenalty": 0,
                "winPenalty": 0,
                "yellowCards": 0
            }
        },
        {
            "amplua": 2,
            "flag": "\/public\/img\/flags\/1.gif",
            "lastname": "\u041b\u0438\u043f\u043e\u0432\u043e\u0439",
            "number": 13,
            "link": "\/team\/player-statistics\/igroki_16.html",
            "stats": {
                "games": 3,
                "goals": 0,
                "lineup": 1,
                "looseGoals": 0,
                "loosePenalty": 0,
                "minutes": 60,
                "penalty": 0,
                "redCards": 0,
                "saves": 0,
                "secondYellowCards": 0,
                "shutout": 0,
                "swapFrom": 1,
                "swapTo": 2,
                "unrealisedPenalty": 0,
                "winPenalty": 0,
                "yellowCards": 0
            }
        },
        {
            "amplua": 1,
            "flag": "\/public\/img\/flags\/1.gif",
            "lastname": "\u041a\u0430\u0440\u043f\u043e\u0432",
            "number": 50,
            "link": "\/team\/player-statistics\/igroki_15.html",
            "stats": []
        },
        {
            "amplua": 2,
            "flag": "\/public\/img\/flags\/1.gif",
            "lastname": "\u041a\u0430\u0431\u0443\u0442\u043e\u0432",
            "number": 7,
            "link": "\/team\/player-statistics\/igroki_14.html",
            "stats": {
                "games": 5,
                "goals": 0,
                "lineup": 0,
                "looseGoals": 0,
                "loosePenalty": 0,
                "minutes": 73,
                "penalty": 0,
                "redCards": 0,
                "saves": 0,
                "secondYellowCards": 0,
                "shutout": 0,
                "swapFrom": 0,
                "swapTo": 5,
                "unrealisedPenalty": 0,
                "winPenalty": 0,
                "yellowCards": 0
            }
        },
        {
            "amplua": 2,
            "flag": "\/public\/img\/flags\/1.gif",
            "lastname": "\u0412\u0438\u0442\u044e\u0433\u043e\u0432",
            "number": 8,
            "link": "\/team\/player-statistics\/igroki_13.html",
            "stats": {
                "games": 8,
                "goals": 0,
                "lineup": 1,
                "looseGoals": 0,
                "loosePenalty": 0,
                "minutes": 238,
                "penalty": 0,
                "redCards": 0,
                "saves": 0,
                "secondYellowCards": 0,
                "shutout": 0,
                "swapFrom": 1,
                "swapTo": 7,
                "unrealisedPenalty": 0,
                "winPenalty": 0,
                "yellowCards": 0
            }
        },
        {
            "amplua": 1,
            "flag": "\/public\/img\/flags\/1.gif",
            "lastname": "\u0411\u043e\u0436\u0438\u043d",
            "number": 47,
            "link": "\/team\/player-statistics\/igroki_12.html",
            "stats": {
                "games": 3,
                "goals": 0,
                "lineup": 2,
                "looseGoals": 0,
                "loosePenalty": 0,
                "minutes": 192,
                "penalty": 0,
                "redCards": 0,
                "saves": 0,
                "secondYellowCards": 0,
                "shutout": 0,
                "swapFrom": 1,
                "swapTo": 1,
                "unrealisedPenalty": 0,
                "winPenalty": 0,
                "yellowCards": 1
            }
        },
        {
            "amplua": 2,
            "flag": "\/public\/img\/flags\/1.gif",
            "lastname": "\u0417\u0438\u043d\u044c\u043a\u043e\u0432\u0441\u043a\u0438\u0439",
            "number": 17,
            "link": "\/team\/player-statistics\/igroki_11.html",
            "stats": {
                "games": 9,
                "goals": 6,
                "lineup": 9,
                "looseGoals": 0,
                "loosePenalty": 0,
                "minutes": 729,
                "penalty": 0,
                "redCards": 0,
                "saves": 0,
                "secondYellowCards": 0,
                "shutout": 0,
                "swapFrom": 7,
                "swapTo": 0,
                "unrealisedPenalty": 0,
                "winPenalty": 0,
                "yellowCards": 0
            }
        },
        {
            "amplua": 2,
            "flag": "\/public\/img\/flags\/1.gif",
            "lastname": "\u0415\u0436\u043e\u0432",
            "number": 11,
            "link": "\/team\/player-statistics\/igroki_10.html",
            "stats": {
                "games": 9,
                "goals": 0,
                "lineup": 8,
                "looseGoals": 0,
                "loosePenalty": 0,
                "minutes": 694,
                "penalty": 0,
                "redCards": 0,
                "saves": 0,
                "secondYellowCards": 1,
                "shutout": 0,
                "swapFrom": 6,
                "swapTo": 1,
                "unrealisedPenalty": 0,
                "winPenalty": 0,
                "yellowCards": 1
            }
        },
        {
            "amplua": 1,
            "flag": "\/public\/img\/flags\/1.gif",
            "lastname": "\u0413\u043e\u0440\u0448\u043a\u043e\u0432",
            "number": 5,
            "link": "\/team\/player-statistics\/igroki_9.html",
            "stats": {
                "games": 9,
                "goals": 0,
                "lineup": 9,
                "looseGoals": 0,
                "loosePenalty": 0,
                "minutes": 842,
                "penalty": 0,
                "redCards": 0,
                "saves": 0,
                "secondYellowCards": 0,
                "shutout": 0,
                "swapFrom": 1,
                "swapTo": 0,
                "unrealisedPenalty": 0,
                "winPenalty": 0,
                "yellowCards": 1
            }
        },
        {
            "amplua": 3,
            "flag": "\/public\/img\/flags\/1.gif",
            "lastname": "\u0410\u0439\u0441\u0430\u0439\u0434\u0443\u043b\u0438\u043d",
            "number": 57,
            "link": "\/team\/player-statistics\/igroki_7.html",
            "stats": []
        },
        {
            "amplua": 3,
            "flag": "\/public\/img\/flags\/1.gif",
            "lastname": "\u041a\u0430\u043d\u0443\u043d\u043d\u0438\u043a\u043e\u0432",
            "number": 99,
            "link": "\/team\/player-statistics\/igroki_6.html",
            "stats": []
        },
        {
            "amplua": 2,
            "flag": null,
            "lastname": "\u0410\u043b\u044c-\u0424\u0443\u0440\u0430\u0438\u0434\u0436\u0438",
            "number": 77,
            "link": "\/team\/player-statistics\/igroki_5.html",
            "stats": []
        },
        {
            "amplua": 1,
            "flag": null,
            "lastname": "\u041f\u0440\u0438\u0449\u0435\u043f\u0430",
            "number": 35,
            "link": "\/team\/player-statistics\/igroki_4.html",
            "stats": []
        },
        {
            "amplua": 2,
            "flag": null,
            "lastname": "\u0410\u043b\u0432\u0435\u0448 \u041a\u043e\u044d\u043b\u044c\u044e \u0434\u0430 \u0421\u0438\u043b\u0432\u0430",
            "number": 16,
            "link": "\/team\/player-statistics\/igroki_3.html",
            "stats": []
        },
        {
            "amplua": 3,
            "flag": null,
            "lastname": "\u041a\u043e\u0440\u043d\u0438\u043b\u0435\u043d\u043a\u043e",
            "number": 12,
            "link": "\/team\/player-statistics\/igroki_2.html",
            "stats": []
        },
        {
            "amplua": 2,
            "flag": null,
            "lastname": "\u0415\u0444\u0440\u0435\u043c\u043e\u0432",
            "number": 22,
            "link": "\/team\/player-statistics\/igroki_1.html",
            "stats": []
        }
    ]
}
